import * as base64Buffer from "base64-arraybuffer";
import {
  getHyDryEventMessagesFromPage,
  HyDryEventMessage,
  HyDryEventsPage,
  HyDryEventMessageCollection,
  HyDryEventCategory,
} from "../models/HyDryEvent";
import { getClientRef } from "./ClientRepository";
import { db } from "@/main";
import {
  getIresDeviceCategoryFromSerialNumber,
  IresDeviceCategory,
} from "../models/IresDevice";
import { firestore } from "firebase";

const PAGE_SIZE = 100;

function getHyDryDeviceEventMessagesCollectionRef() {
  return db.doc(getClientRef()).collection("hyDryEventMessages");
}

export function observeHyDryDeviceEventMessages(
  onNext: (eventInfo: HyDryEventMessageCollection) => void
) {
  return getHyDryDeviceEventMessagesCollectionRef().onSnapshot((snapshot) => {
    const messages = snapshot.docs.flatMap((doc) => {
      return getHyDryEventMessagesFromPage(doc.data() as HyDryEventsPage);
    });

    const sortedResult = messages.sort(
      (a, b) =>
        b.unreadMessages[0].latestMessage.messageDate.getTime() -
        a.unreadMessages[0].latestMessage.messageDate.getTime()
    );

    onNext({
      latestHyDryEventMessages: sortedResult,
    });
  });
}

function getRef(serialNumber: string) {
  const deviceNumberString = serialNumber.replace(/[^0-9]/g, "");
  const deviceNumber =
    deviceNumberString.length === 0 ? 0 : parseInt(deviceNumberString, 10);

  const page = `page_${Math.floor(deviceNumber / PAGE_SIZE)}`;
  return getHyDryDeviceEventMessagesCollectionRef().doc(page);
}

function encodeEvent(
  hyDryEventInfo: HyDryEventMessage,
  wasRead: boolean
): string {
  const encodedData = new Uint8Array(5);

  encodedData[0] = wasRead ? 1 : 0;
  encodedData[0] += hyDryEventInfo.eventNumber << 1;

  let timestampMinutes = Math.floor(
    hyDryEventInfo.messageDate.getTime() / (60 * 1000)
  );

  for (let i = 0; i < 4; i++) {
    encodedData[4 - i] = timestampMinutes % 256;
    timestampMinutes = timestampMinutes >>> 8;
  }

  return base64Buffer.encode(encodedData);
}

export async function updateHyDryEventInfo(
  hyDryEventInfo: HyDryEventMessage,
  update: string
) {
  const serialNumber = hyDryEventInfo.serialNumber;
  const iresDeviceCategory = getIresDeviceCategoryFromSerialNumber(
    serialNumber
  );
  const collectionName =
    iresDeviceCategory === IresDeviceCategory.PANEL ? "panels" : "comBoxes";

  const pageUpdate = {
    [collectionName]: {
      [serialNumber]: {
        [hyDryEventInfo.eventCategory]: update,
      },
    },
  };

  return getRef(serialNumber).set(pageUpdate, { merge: true });
}

export async function deleteAllHyDryEventMessagesForSerialNumber(
  serialNumber: string,
  categories: HyDryEventCategory[]
) {
  const iresDeviceCategory = getIresDeviceCategoryFromSerialNumber(
    serialNumber
  );
  const collectionName =
    iresDeviceCategory === IresDeviceCategory.PANEL ? "panels" : "comBoxes";

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const pageUpdate: any = {};

  categories.forEach((category) => {
    pageUpdate[
      `${collectionName}.${serialNumber}.${category}`
    ] = firestore.FieldValue.delete();
    pageUpdate[
      `${collectionName}.${serialNumber}.unread.${category}`
    ] = firestore.FieldValue.delete();
  });

  return getRef(serialNumber).update(pageUpdate);
}

export async function markHyDryEventMessageAsRead(
  hyDryEventInfo: HyDryEventMessage
) {
  return updateHyDryEventInfo(
    hyDryEventInfo,
    encodeEvent(hyDryEventInfo, true)
  );
}
